/** @format */

export interface S1Cta {
  label?: string;
  link?: string;
}

export interface S1PersonalizationData {
  image?: string;
  headline?: string;
  subHeadline?: string;
  primaryCta?: S1Cta;
  secondaryCta?: S1Cta;
  redBannerText?: string;
}
